<template>
  <div>
    <v-input
    :value="isValidAnswer"
    :rules="question.isMandatory ? [requiredRules] : []"
  >
    <v-row class="mt-3">
      <v-simple-table style="width: 100%; margin-bottom: 16px">
        <template v-slot:default>
          <thead>
            <tr>
              <th style="width: 300px"></th>
              <th class="text-left" v-for="(head, index) in options" :key="`opt-${index}-${head.value}`">
                <div>
                  {{ head.text }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="items" v-for="(item, key) in statement" :key="`statement-${key}-${item.value}`">
            <tr class="mt-2" :class="[item.comment ? 'have-comment' : 'comment-border']">
              <td style="max-width: 200px; item-align: center">
                <div>
                  {{ item.text }}
                </div>
              </td>
              <td v-for="(head, index) in options" :key="`opt-list-${index}-${head.value}`">
                <v-radio-group
                  dense
                  v-model="item.value"
                  row
                  hide-details
                  class="mt-0 pb-1"
                  :disabled="isReadOnly"
                >
                  <v-radio :value="head.value" v-if="question.isAskComment" @mousedown.prevent="openConfirmation(head.value, key)"></v-radio>
                  <v-radio :value="head.value" v-else></v-radio>
                </v-radio-group>
              </td>
            </tr>
            <tr v-if="item.comment" class="comment-border">
              <td></td>
              <td :colspan="options.length" class="text-subtitle-1">
                
                <div
                  dense
                  outlined
                  color="grey lighten-2"
                  class="pa-2 mb-4"
                  style="max-width: 80vw; border: thin solid rgba(0, 0, 0, 0.12); border-radius: 4px; overflow-wrap: break-word;"
                >
               <span class="grey--text text--darken-2">{{ item.comment }}</span> 
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-row>
  </v-input>
  <likertTypeComment
      v-if="commentDialog"
      v-model="commentDialog"
      :comment="commentText"
      @change="confirmSelection"
    >
    </likertTypeComment>
  </div>
  
</template>

<script>
import LikertTypeComment from "./LikertTypeComment.vue";
export default {
  name: "LikertType",
  components: {
    LikertTypeComment,
  },
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    answer: {
      type: Array,
      default: () => [],
    },
    isReadOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      commentDialog: false,
      tempSelection: null,
      tempItemIndex: null,
      commentText: ''
    };
  },
  computed: {
    options() {
      return this.question.options.options;
    },
    statement() {
      if (this.question.selectedAnswer === null) {
        this.question.selectedAnswer = this.question.options.statement;
      }
      return this.question.selectedAnswer;
    },
    isValidAnswer() {
      return this.question.selectedAnswer
        ? !this.question.selectedAnswer.some((m) => m.value === null)
        : false;
    },
  },
  methods: {
    requiredRules(value) {
      return !!value || this.$t("poll.ruleQuestionReq");
    },
    openConfirmation(value, item) {
    if(this.statement[item] && this.statement[item].value === value){
      return;
    }
      this.tempSelection = value; // Store the clicked radio button's value
      this.tempItemIndex = item;
      this.commentDialog = true;  // Open the dialog
      if(this.statement[item].comment){
        this.commentText = this.statement[item].comment
      }else{
        this.commentText = ''
      }
    },
    confirmSelection(comment) {
      this.statement[this.tempItemIndex].value = this.tempSelection;
      this.statement[this.tempItemIndex].comment = comment
    },
    
  },
};
</script>

<style scoped>
.have-comment td{
  border-bottom: none !important;
}
tbody.items tr:hover{
  background: none !important;
}
tbody.items:hover{
  background: #eeeeee;
}
tbody.items tr.comment-border td{
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important
}
</style>